import { call, put, takeLatest } from "redux-saga/effects";
import { dropdownActions } from "./index";
import request from "utils/request";

/* ===================== CATEGORIES ===================== */
function* getCategoriesSaga(action) {
  try {
    const search = action.payload?.search || "";

    const url = search
      ? `/api/get-categories?search=${encodeURIComponent(search)}`
      : "/api/get-categories";

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getCategoriesSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getCategoriesFailure(
        error.message || "Categories fetch failed"
      )
    );
  }
}

/* ===================== LANGUAGES ===================== */
function* getLanguagesSaga(action) {
  try {
    const search = action.payload?.search || "";

    const url = search
      ? `/api/get-languages?search=${encodeURIComponent(search)}`
      : `/api/get-languages`;

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getLanguagesSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getLanguagesFailure(
        error.message || "Languages fetch failed"
      )
    );
  }
}

/* ===================== COMPANIES ===================== */
function* getCompaniesSaga(action) {
  try {
    const search = action.payload?.search || "";
    const type = action.payload?.type || "";

    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (type) params.append("type", type);

    const url = `/api/get-companies${params.toString() ? `?${params.toString()}` : ""}`;

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getCompaniesSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getCompaniesFailure(
        error.message || "Companies fetch failed"
      )
    );
  }
}

/* ===================== CITIES ===================== */
function* getCitiesSaga(action) {
  try {
    const search = action.payload?.search || "";
    const state_id = action.payload?.state_id || "";

    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (state_id) params.append("state_id", state_id);

    const url = `/api/get-cities${params.toString() ? `?${params.toString()}` : ""}`;

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getCitiesSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getCitiesFailure(
        error.message || "Cities failed to fetch"
      )
    );
  }
}

/* ===================== STATES ===================== */
function* getStatesSaga(action) {
  try {
    const search = action.payload?.search || "";

    const url = search
      ? `/api/get-states?search=${encodeURIComponent(search)}`
      : `/api/get-states`;

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getStatesSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getStatesFailure(
        error.message || "States failed to fetch"
      )
    );
  }
}

/* ===================== PRIMARY CATEGORIES ===================== */
function* getPrimaryCategoriesSaga(action) {
  try {
    const search = action.payload?.search || "";

    const url = search
      ? `/api/get-primary-categories?search=${encodeURIComponent(search)}`
      : "/api/get-primary-categories";

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getPrimaryCategoriesSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getPrimaryCategoriesFailure(
        error.message || "Primary categories fetch failed"
      )
    );
  }
}

/* ===================== SUB CATEGORIES ===================== */
function* getSubCategoriesSaga(action) {
  try {
    const search = action.payload?.search || "";
    const primaryCategoryIds = action.payload?.primaryCategoryIds || [];

    const params = new URLSearchParams();
    if (search) params.append("search", search);
    primaryCategoryIds.forEach((id) => params.append("primaryCategoryId", id));

    const url = `/api/get-sub-categories${params.toString() ? `?${params.toString()}` : ""}`;
    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");
    yield put(dropdownActions.getSubCategoriesSuccess(response.data));
  } catch (error) {
    yield put(dropdownActions.getSubCategoriesFailure(error.message));
  }
}

function* getTalentAgencyManagersSaga(action) {
  try {
    const talent_company_id = action.payload?.talent_company_id || "";

    const url = talent_company_id
      ? `/api/get-talent-agency-managers?talent_company_id=${encodeURIComponent(talent_company_id)}`
      : `/api/get-talent-agency-managers`;

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getTalentAgencyManagersSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getTalentAgencyManagersFailure(
        error.message || "Talent agency managers fetch failed"
      )
    );
  }
}

function* getCreatorPlansSaga(action) {
  try {
    const search = action.payload?.search || "";

    const url = search
      ? `/api/get-creator-plans?search=${encodeURIComponent(search)}`
      : "/api/get-creator-plans";

    const response = yield call(request, url, {
      method: "GET",
      credentials: "include"
    });

    if (!response?.success) throw new Error("Failed");

    yield put(dropdownActions.getCreatorPlansSuccess(response.data));
  } catch (error) {
    yield put(
      dropdownActions.getCreatorPlansFailure(
        error.message || "Creator plans fetch failed"
      )
    );
  }
}
export function* dropdownSaga() {
  yield takeLatest(
    dropdownActions.getCategoriesRequest.type,
    getCategoriesSaga
  );
  yield takeLatest(dropdownActions.getLanguagesRequest.type, getLanguagesSaga);
  yield takeLatest(dropdownActions.getCompaniesRequest.type, getCompaniesSaga);
  yield takeLatest(dropdownActions.getCitiesRequest.type, getCitiesSaga);
  yield takeLatest(dropdownActions.getStatesRequest.type, getStatesSaga);
  yield takeLatest(
    dropdownActions.getPrimaryCategoriesRequest.type,
    getPrimaryCategoriesSaga
  );
  yield takeLatest(
    dropdownActions.getSubCategoriesRequest.type,
    getSubCategoriesSaga
  );
  yield takeLatest(
    dropdownActions.getTalentAgencyManagersRequest.type,
    getTalentAgencyManagersSaga
  );
  yield takeLatest(
    dropdownActions.getCreatorPlansRequest.type,
    getCreatorPlansSaga
  );
}
